<template>
  <div>
    <p>
      Server provozuje:
      <br />
      Ústav zdravotnických informací a statistiky ČR -
      <a href="https://www.uzis.cz/" target="_blank">ÚZIS ČR</a>.
    </p>
    <div class="contributors">
      <img
        src="@/assets/mzcr.gif"
        alt="Logo Ministerstva zdravotnictví ČR"
        title="Ministerstvo zdravotnictví ČR"
      />
      <img
        src="@/assets/uzis_logo.png"
        alt="Logo ÚZIS ČR"
        title="Ústav zdravotnických informací a statistiky ČR"
      />
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$emit("caption", "O aplikaci");
  }
};
</script>

<style scoped>
.side {
  padding: 2.5em;
  font-family: Arial, Helvetica, sans-serif;
  padding-top: 0;
}

.contributors {
  margin-top: 4em;
  padding: 1.5em;
  padding-bottom: 0;
}

.contributors img {
  display: block;
  width: 100%;
  margin-bottom: 1.5em;
}
</style>
